import { Component, OnInit } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from './core/services/auth.service';
import { LanguageService } from './core/services/language.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule, RouterOutlet, RouterLink,
    MatToolbarModule, MatButtonModule, MatIconModule, MatMenuModule, MatDividerModule,
    TranslateModule
  ],
  template: `
    <mat-toolbar color="primary" class="app-toolbar">
      <a [routerLink]="auth.isLoggedIn() ? (auth.userRole() === 'MAKER' ? '/maker' : '/checker') : '/login'" class="toolbar-brand">
        <img src="assets/images/warba-logo.svg" class="toolbar-logo" alt="Warba Logo" />
      </a>

      <span class="spacer"></span>

      @if (!isLoginPage()) {
        @if (auth.isLoggedIn()) {
          <!-- User menu -->
          <button mat-button [matMenuTriggerFor]="userMenu">
            <mat-icon>account_circle</mat-icon>
            {{ auth.currentUser()?.name }}
          </button>
          <mat-menu #userMenu="matMenu">
            <div mat-menu-item disabled style="font-size:12px;opacity:.6">
              {{ auth.currentUser()?.role }}
            </div>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="auth.logout()">
              <mat-icon>logout</mat-icon>
              {{ 'nav.logout' | translate }}
            </button>
          </mat-menu>
        } @else {
          <a mat-button routerLink="/login">{{ 'nav.login' | translate }}</a>
        }
      }

      <!-- Language dropdown -->
      <button mat-button [matMenuTriggerFor]="langMenu" class="lang-btn">
        <span class="flag">{{ lang() === 'ar' ? '🇸🇦' : '🇬🇧' }}</span>
        <span class="lang-label">{{ lang() === 'ar' ? 'العربية' : 'English' }}</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #langMenu="matMenu">
        <button mat-menu-item (click)="langService.setLang('en')" [class.active-lang]="lang() === 'en'">
          <span class="flag">🇬🇧</span> English
        </button>
        <button mat-menu-item (click)="langService.setLang('ar')" [class.active-lang]="lang() === 'ar'">
          <span class="flag">🇸🇦</span> العربية
        </button>
      </mat-menu>
    </mat-toolbar>

    <router-outlet></router-outlet>
  `,
  styles: [`
    .app-toolbar { position: sticky; top: 0; z-index: 100; }
    .toolbar-brand { display: flex; align-items: center; text-decoration: none; }
    .toolbar-logo { height: 36px; width: auto; object-fit: contain; cursor: default }
    .active-link { background: rgba(255,255,255,0.15); border-radius: 4px; }
    .spacer { flex: 1 1 auto; }
    .lang-btn { color: white; display: flex; align-items: center; gap: 4px; }
    .lang-btn .flag { font-size: 18px; line-height: 1; }
    .lang-btn .lang-label { font-size: 13px; font-weight: 600; }
    .flag { font-size: 20px; margin-right: 8px; }
    .active-lang { background: rgba(0,0,0,0.08); font-weight: 700; }
  `]
})
export class AppComponent implements OnInit {
  lang = this.langService.lang;

  constructor(public auth: AuthService, public langService: LanguageService, private router: Router) {}

  get isLoginPage(): () => boolean {
    return () => this.router.url === '/login' || this.router.url === '/register';
  }

  ngOnInit() {
    this.langService.init();
  }
}
